import { Box } from '@mui/material';
import styled from 'styled-components';

export const GraphWrapper = styled(Box)`
  background-color: ${({ theme }) => theme.palette.base.background};
  border-radius: 6px;
  box-shadow: ${({ theme }) => theme.shadows[27]};
  padding: 24px;
`;
